/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Maybe } from "graphql/jsutils/Maybe";
import { generateActionConfirmText } from "~/tools";

export const text = {
  rotateApiKey: {
    warning: {
      text: "Please be informed, after you recreate the API Key Secret, your original API Key Secret will be revoked.",
      areYouSure: (id: string, description: string) =>
        generateActionConfirmText(`"${id}" ${description}`)(
          "recreate API Key Secret for API Key ID"
        )(),
      button: "Recreate API Key Secret",
      caption: "Recreate API Key Secret",
    },
    result: {
      success: "Generated credentials",
      warning:
        "Make sure to copy secret value now. You won’t be able to see it again!",
    },
  },
  deleteApiKey: {
    warning: {
      areYouSure: (id: string, description: Maybe<string>) =>
        generateActionConfirmText(`"${id}" ${description + " " ?? ""}API Key`)(
          "delete"
        )(),
      button: "Delete API Key",
      caption: "Delete API Key",
    },
  },
  forms: {
    accessDescription: {
      full: "You will have admin access to IBM Multicloud Accelerator API. You will have access to all functionality in IBM Multicloud Accelerator API and you will be able to view, edit and delete them.",
      readonly:
        "You will have read-only access to IBM Multicloud Accelerator API. You will have access to all functionality in IBM Multicloud Accelerator, but you will not be able to edit or delete something.",
      restricted:
        "You will have access only to selected applications in IBM Multicloud Accelerator API.",
    },
  },
};
